(function () {
    'use strict';

    /*
     * NC_PRAGERU_MENU_12 — "VIP Value" PragerUnited CTA in the mobile menu.
     *
     * Shoplift API test, MANUAL trigger: this file ships in the PUBLISHED theme, for both
     * groups. The call to isHypothesisActive, on the first gesture that opens the menu on a
     * phone, enters the visitor — control and variant alike. Nobody enters the test without
     * opening the menu, and desktop visitors never do. The button keeps its link and theme
     * styling: only its label changes, and the "Member perks" strip is added under it.
     */

    var HYPOTHESIS_ID = '01a13b06-db5b-747a-87b0-dbb602463b50';
    var PREVIEW = 'nc-menu-12';

    var CTA_TEXT = 'Unlock PragerUnited VIP Perks';
    var ICON_STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2.5l2.9 6 6.6.8-4.9 4.5 1.3 6.5L12 17l-5.9 3.3 1.3-6.5L2.5 9.3l6.6-.8z"/></svg>';

    /** The strip (label, icons, texts) lives in snippets/nc-test-menu-12-perks.liquid. */
    var PERKS_TEMPLATE = 'nc-menu-12-perks-template';

    var TOGGLE = 'summary.main-menu__toggle';
    var CTA = '.main-menu__content .secondary-nav__cta';
    var MOBILE_QUERY = '(max-width: 768.98px)';

    /*
     * The button is hidden from the gesture until Shoplift answers, for BOTH groups — so a
     * label never switches under the shopper's eyes, and both groups keep the same rhythm.
     * It is revealed on the answer, or at the latest after this ceiling.
     */
    var CEILING_MS = 400;
    /** Time given to the Shoplift object to appear: it arrives after its initialization. */
    var WAIT_MS = 1500;
    var asked = false;

    function previewAsked() {
        try {
            var q = new URLSearchParams(window.location.search).get(PREVIEW);
            if (q === 'on') window.sessionStorage.setItem(PREVIEW, '1');
            if (q === 'off') window.sessionStorage.removeItem(PREVIEW);
            return window.sessionStorage.getItem(PREVIEW) === '1';
        } catch (error) {
            return false;
        }
    }

    function mask(active) {
        var cta = document.querySelector(CTA);
        if (cta) cta.style.visibility = active ? 'hidden' : '';
    }

    function apply() {
        var cta = document.querySelector(CTA);
        if (!cta || cta.classList.contains('nc-menu-12-cta')) return;

        var label = cta.querySelector('span') || cta;
        label.innerHTML = ICON_STAR + '<span></span>';
        label.lastChild.textContent = CTA_TEXT;
        cta.classList.add('nc-menu-12-cta');

        var template = document.getElementById(PERKS_TEMPLATE);
        if (!template) return;
        var strip = template.content.firstElementChild.cloneNode(true);
        var anchor = cta.closest('ul') || cta.closest('li') || cta;
        anchor.after(strip);
    }

    function whenShopliftIsReady(next) {
        var start = Date.now();

        (function attempt() {
            if (window.shoplift && window.shoplift.isHypothesisActive) return next(true);
            if (Date.now() - start > WAIT_MS) return next(false);
            window.setTimeout(attempt, 50);
        })();
    }

    /*
     * Entering the test. The mask is lifted by the ceiling even if the answer is slow; if it
     * arrives later and says "variant", the variant is applied anyway: a contaminated arm
     * skews the test, a label that changes late does not.
     */
    function enter() {
        if (asked) return;
        if (!window.matchMedia(MOBILE_QUERY).matches) return;
        if (!document.querySelector(CTA)) return;
        asked = true;

        if (previewAsked()) {
            apply();
            return;
        }

        mask(true);
        var timer = window.setTimeout(function () {
            mask(false);
        }, CEILING_MS);

        whenShopliftIsReady(function (present) {
            if (!present) {
                window.clearTimeout(timer);
                mask(false);
                return;
            }

            window.shoplift
                .isHypothesisActive(HYPOTHESIS_ID)
                .then(function (isVariant) {
                    if (isVariant) apply();
                })
                .catch(function () {
                    /* The control stays in place: the fallback when assignment fails. */
                })
                .then(function () {
                    window.clearTimeout(timer);
                    mask(false);
                });
        });
    }

    /*
     * The gate. `pointerdown` fires before the panel opens; `click` catches keyboard opening,
     * where no pointer went down. Both in the capture phase, so no theme handler can stop them.
     */
    function onGesture(event) {
        var target = event.target;
        if (target && target.closest && target.closest(TOGGLE)) enter();
    }

    document.addEventListener('pointerdown', onGesture, true);
    document.addEventListener('click', onGesture, true);
})();
